import { useEffect, useState } from "react"
import { Button, FormGroup, Input, Label, Modal, ModalBody } from "reactstrap"
import CustomDropzone from "components/CustomDropzone"
import { confirm } from "components/Confirmation"
import { alert } from "components/Alert"

export default function ModalLancarDivergencia({ config, onClosed }) {
  const [observacao, setObservacao] = useState('')
  const [fotos, setFotos] = useState([])

  useEffect(() => {
    setObservacao('')
    setFotos([])
  }, [config])

  const handleChangeFoto = (index, file) => {
    const novasFotos = [...fotos]
    novasFotos[index] = file
    setFotos(novasFotos)
  }

  const handleRemoveFoto = (index) => {
    setFotos(fotos.filter((_, i) => i !== index))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!observacao) {
      alert({ text: 'Informe a observação da divergência.' })
      return
    }

    confirm({
      header: "Lançar divergência",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        if (config.onSubmit) {
          await config.onSubmit(observacao, fotos.filter(Boolean))
        }
        onClosed && onClosed()
      }
    })
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Lançar Divergência</h2>
        <div className="text-dark mb-2">
          {config?.item?.codigo} - {config?.item?.descricao}
        </div>
        <hr />
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Observação</Label>
            <Input type="textarea" rows={4} value={observacao} onChange={e => setObservacao(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Fotos (opcional)</Label>
            <div className="d-flex flex-row flex-wrap" style={{ gap: 16 }}>
              {[...fotos, null].map((foto, index) => (
                <div key={index} style={{ width: 200 }}>
                  <CustomDropzone
                    value={foto}
                    edit={true}
                    onChange={file => handleChangeFoto(index, file)}
                    onRemove={() => handleRemoveFoto(index)}
                  />
                </div>
              ))}
            </div>
          </FormGroup>
          <div className="text-right mt-4">
            <Button type="submit" color="primary">Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}
